'use client';

import { Check, ChevronDown } from 'lucide-react';

import React, { useMemo } from 'react';

import { SimpleDropdown } from '@/shared/components';
import type { DropdownOption } from '@/shared/components/SimpleDropdown';

import { cn } from '@/lib/utils';

import { useHLSPlayer } from '../contexts/hls-player-provider';
import type { IControlsProps } from '../types';
import { SPEED_OPTIONS } from '../types';

type SpeedControlProps = IControlsProps;

function SpeedControl({ className }: SpeedControlProps) {
	const { playbackState, changeSpeed } = useHLSPlayer();
	const { playbackSpeed } = playbackState;

	const dropdownOptions = useMemo<DropdownOption[]>(
		() =>
			SPEED_OPTIONS.map((speed) => ({
				icon: playbackSpeed === speed ? <Check size={16} /> : <div className="size-4" />,
				label: `${speed}x`,
				value: `speed-${speed}`,
				onClick: () => changeSpeed(speed),
			})),
		[playbackSpeed, changeSpeed]
	);

	return (
		<SimpleDropdown
			options={dropdownOptions}
			dropdownAlign="end"
			className="min-w-[100px]"
		>
			<button
				className={cn(
					'flex h-7 items-center justify-center gap-0.5 rounded-md px-1 py-0 text-white transition-colors hover:bg-white/20',
					className
				)}
				aria-label="Playback speed"
			>
				{/* <Gauge size={16} /> */}
				<span className="text-xs font-medium">{playbackSpeed}x</span>
				<ChevronDown className="size-3 translate-y-0.5" />
			</button>
		</SimpleDropdown>
	);
}

export default React.memo(SpeedControl);
